import { render } from "./BankIcon.vue?vue&type=template&id=dda9b8d4"
const script = {}

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__